import React, { RefObject, SyntheticEvent } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { bindActionCreators } from "redux";
import { EditorMode, FeatureCategory, FieldFormat, FieldType, IAdHocGroupProject, IAdHocProject, IAdHocProjectResult, IAppSettings, IApplicationState, IAsset, IAssetMetadata, IClearLabelDataCommand, IHatchetAiCompanyProjectOcr, ILabel, IProject, IProjectLabel, IRegion, ISize, ITableConfigItem, ITableRegion, ITableTag, ITag, TableVisualizationHint, TagInputMode } from "../../../../models/applicationState";
import IAdHocOcrActions, * as adHocActions from "../../../../redux/actions/adHocOcrActions";
import IAdHocOcrV2Actions, * as adHocV2Actions from "../../../../redux/actions/adHocOcrV2Actions";
import SplitPane from "react-split-pane";
import Canvas from "../adhococrv2/canvas";
import { TagInput } from "../../common/tagInput/tagInput";
import { OcrStatus } from "../../../../services/ocrService";
import { AssetPreview } from "../../common/assetPreview/assetPreview";
import IProjectActions from "../../../../redux/actions/projectActions";
import * as projectActions from "../../../../redux/actions/projectActions";
import _ from "lodash";
import "../editorPage/editorPage.scss";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import { constants } from "../../../../common/constants";
import CanvasHelpers from "../editorPage/canvasHelpers";
import Confirm from "../../common/confirm/confirm";
import clone from "rfdc";
import { getCookieEmail, parseEndpointByType } from "../../common/jsonSchemaFormHelper";
import axios from "axios";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import {
    getPrimaryBlueTheme,
    getPrimaryRedTheme,
} from "../../../../common/themes";
import { AssetService } from "../../../../services/assetService";
import EditLabelDialog from "../../common/editLabelDialog/editLabelDialog";
import { toast } from "react-toastify";
import { TableView } from "../adhococrv2/tableView";
import SearchDialog from "../../common/searchDialog/searchDialog";
import EditorSideBar from "./editorSideBar";
import { Spinner } from "reactstrap";
import { SpinnerSize } from "@fluentui/react";
import IAdHocOcrV3Actions, * as adHocOcrV3Actions from "../../../../redux/actions/adHocOcrV3Actions";

interface IIntegrationV2PageProps extends RouteComponentProps, React.Props<adHocOcrV2GroupPage> {
    adHocOcr: IAdHocProject;
    adHocActions: IAdHocOcrActions;
    adHocV2Actions: IAdHocOcrV2Actions;
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    adHocOcrV3Group: IAdHocGroupProject;
    adHocOcrV3Actions: IAdHocOcrV3Actions;
    adHocOcrV3: IAdHocProject;
}

interface IIntegrationV2PageState {
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    editorMode: EditorMode;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    isRunningOCRs?: boolean;
    tagInputMode: TagInputMode;
    highlightedTableCellRegions: ITableRegion[];
    selectedTableTagToLabel: ITableTag;
    isValid: boolean;
    assets: IAsset[];
    thumbnailSize: ISize;
    sidePanelSize: number;
    selectedRegions?: IRegion[];
    pageNumber: number;
    selectedTableTagBody: ITableRegion[][][];
    rightSplitPaneWidth?: number;
    reconfigureTableConfirm?: boolean;
    projectLabels: IProjectLabel[];
    showEditDialog?: boolean;
    labelToEdit?: ILabel;
    isProcessingLabel?:boolean;
    runGenerateModel:boolean;
    tableToViewId: string;
    tableToView: null,
    showSearch?: boolean;
    refreshKey?: number;
    selectedRequestId?: string;
    modelProjects?: Array<{ key: string; val: string }>;
    isPageLoading: boolean;
}

function mapStateToProps(state: IApplicationState) {
    return {
        adHocOcr: state.adHocOcrV2,
        appSettings: state.appSettings,
        adHocOcrV3Group: state.adHocOcrV3Group,
        adHocOcrV3: state.adHocOcrV3
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        adHocActions: bindActionCreators(adHocActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),        
        adHocV2Actions: bindActionCreators(adHocV2Actions, dispatch),
        adHocOcrV3Actions: bindActionCreators(adHocOcrV3Actions, dispatch) // <-- fix here
    }
}

@connect(mapStateToProps, mapDispatchToProps)
export default class adHocOcrV2GroupPage extends React.Component<IIntegrationV2PageProps, IIntegrationV2PageState> {
    groupId: string;

    private editorSidebarRef: RefObject<EditorSideBar>;
    private canvas: RefObject<Canvas> = React.createRef();
    private tagInputRef: RefObject<TagInput>;
    public initialRightSplitPaneWidth: number;
    private renameCanceled: () => void;
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteTagsConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();
    private replaceConfirmRef = React.createRef<Confirm>();
    private reconfigTableConfirm: React.RefObject<Confirm> = React.createRef();
    private confirmResetTagConfirm = React.createRef<Confirm>();
    private editLabelDialogRef: React.RefObject<EditLabelDialog> =
        React.createRef();
    private searchDialogRef: React.RefObject<SearchDialog> = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            editorMode: EditorMode.Select,
            lockedTags: [],
            hoveredLabel: null,
            tagInputMode: TagInputMode.Basic,
            highlightedTableCellRegions: null,
            selectedTableTagToLabel: null,
            isValid: true, 
            assets: [],
            thumbnailSize: { width: 175, height: 155 },
            sidePanelSize: 248,
            pageNumber: 1,
            selectedTableTagBody: [[]],
            projectLabels: [],
            isProcessingLabel: false,
            runGenerateModel: false,
            tableToViewId: null,
            tableToView: null,
            refreshKey: 0,
            isPageLoading: true,
            rightSplitPaneWidth: 290, // Default width for the right split pane based on tag input mode
        }
        this.tagInputRef = React.createRef();

        this.onTagDeleteChecked = this.onTagDeleteChecked.bind(this);
        this.downloadToExcelClick = this.downloadToExcelClick.bind(this);       
        this.processingLabel = this.processingLabel.bind(this);

        this.loadAdHocOcrProject = this.loadAdHocOcrProject.bind(this);

        this.onGenerateModelChanged = this.onGenerateModelChanged.bind(this);
    }
    public async componentDidMount() {
        let url = new URL(window.location.href);
        this.groupId = url.searchParams.get("groupId");
        if (this.groupId) {
            try {
                this.props.applicationActions.setWidgetMode();
                await this.props.adHocOcrV3Actions.loadAdHocOcrV3GroupProject(this.groupId);
                await this.loadSelectedProject();
                // setTimeout(() => {
                //     if (this.props?.adHocOcrV3?.status) {
                //         if (!!this.canvas.current) {
                //             if (this.props?.adHocOcrV3?.status === 'ready') {
                //                 this.canvas.current.toggleDrawRegionMode(false);
                //             }
                //             else {
                //                 this.canvas.current.toggleDrawRegionMode(true);
                //             }
                //         }                        
                //     }         
                // }, 300);
            }
            catch(e) {
                toast.error(e);
            }
            document.title = "HatchetAI";
        }        
    }

    async componentDidUpdate(prevProps: Readonly<IIntegrationV2PageProps>, prevState: Readonly<IIntegrationV2PageState>, snapshot?: any) {
        // if ((prevProps == null || prevProps.adHocOcrV3 == null || prevProps.adHocOcrV3.project == null) && this.props?.adHocOcrV3?.project) {
        //     await this.loadFirstProject();
        // }

        if (this.props?.adHocOcrV3?.project && prevProps?.adHocOcrV3?.project && 
            prevProps.adHocOcrV3.project.id === this.props.adHocOcrV3.project.id && 
            prevProps.adHocOcrV3.status === "Queued" && 
            this.props.adHocOcrV3.status === "Ready") {
            await this.loadSelectedProject(true);
            // this.setState({
            //     selectedRequestId: this.props.adHocOcrV3.project.id
            // });
        }

        if (this.props?.adHocOcrV3?.project && prevProps?.adHocOcrV3?.project && prevProps.adHocOcrV3.project.id !== this.props.adHocOcrV3.project.id) {
            //await this.loadSelectedProject();
            // this.setState({
            //     selectedRequestId: this.props.adHocOcrV3.project.id
            // });
        }

        if (prevProps && prevProps.adHocOcrV3Group && this.props && this.props.adHocOcrV3Group) {
            if (JSON.stringify(prevProps.adHocOcrV3Group) !== JSON.stringify(this.props.adHocOcrV3Group) && 
                this.props.adHocOcrV3Group.adhocGroupProjects && this.props.adHocOcrV3Group.adhocGroupProjects.length > 0) {
                //alert('CHECK IF ALL ARE POSTED');
                const allPosted = this.props.adHocOcrV3Group.adhocGroupProjects.filter(r => r.status.toLowerCase() !== "posted").length === 0;
                if (allPosted) {
                    setTimeout(function() {
                        window.close();
                    }, 500);                    
                }
                else {
                    await this.loadSelectedProject();
                }
            }
        }
    }

    private async loadSelectedProject(isJobDone?: boolean) {
        if (isJobDone && this.state.selectedRequestId === this.props.adHocOcrV3.project.id) {
            await this.loadProjectAssets();
            if (this.props?.adHocOcrV3?.project) {
                this.setState({
                    selectedRequestId: this.props.adHocOcrV3.project.id
                });
            }
        }    
        else if (this.state.selectedRequestId !== this.props.adHocOcrV3.project.id) {
            await this.loadProjectAssets();
            if (this.props?.adHocOcrV3?.project) {
                this.setState({
                    selectedRequestId: this.props.adHocOcrV3.project.id
                });
            }
        }    
        if (this.props.adHocOcrV3Group && this.props.adHocOcrV3Group.adhocGroupProjects && this.props.adHocOcrV3Group.adhocGroupProjects.length > 0) {
            let { modelProjects } = this.state;
            const groupByVendor = this.props.adHocOcrV3Group.adhocGroupProjects.reduce((acc, item) => {
                if (!item.hasModel && !item.hasRunningRequest) {
                    const key = item.vendor;
                    if (!acc[key]) {
                        acc[key] = [];
                    }
                    acc[key].push(item.project.id);
                }
                return acc;
            }, {});

            
            let firstElements: Array<{ key: string; val: string; }> = Object.entries(groupByVendor).map(
                ([key, valueArray]) => ({
                    key,
                    val: valueArray[0]
                })
            );
            modelProjects = modelProjects ? modelProjects : [];
            firstElements.forEach((element) => {
                const exists = modelProjects.some((project) => project.key === element.key);
                let hasModel = false;
                if (!exists) {                        
                    modelProjects.push(element); // Add the element if the key is not already present
                }
            });
            this.setState({
                modelProjects
            });
            const modelProjectsClone = JSON.parse(JSON.stringify(this.state.modelProjects));
            this.props.adHocV2Actions.setGenerateModelGroup(modelProjectsClone);
            // this.setState((prevState) => {
            //     let updatedModelProjects = prevState.modelProjects ? [...prevState.modelProjects] : []; // Create a copy of modelProjects
            
            //     // Iterate over firstElements and add missing elements to updatedModelProjects
            //     firstElements.forEach((element) => {
            //         const exists = updatedModelProjects.some((project) => project.key === element.key);
            //         let hasModel = false;
            //         if (!exists) {                        
            //             updatedModelProjects.push(element); // Add the element if the key is not already present
            //         }
            //     });
            
            //     return {
            //         modelProjects: updatedModelProjects, // Update the state with the new array
            //     };
            // }, () => {
            //     setTimeout(() => {
            //         const modelProjectsClone = JSON.parse(JSON.stringify(this.state.modelProjects));
            //         this.props.adHocV2Actions.setGenerateModelGroup(modelProjectsClone);  
            //     }, 300);                        
            // });
        }
    }

    private handleTableViewClose = () => {
        this.closeTableView("rest");
    };

    onGenerateModelChanged(vendor, projectId, checked) {
        let { modelProjects } = this.state;
        let generateModel = false;
        if (modelProjects && modelProjects.length > 0) {
            let kvp = modelProjects.find(r => r.key === vendor);
            if (kvp) {
                if (checked) {
                    kvp.val = projectId;
                }
                else {
                    kvp.val = '';
                }
                // if (kvp.val === projectId) {
                //     kvp.val = '';
                // }
                // else {
                //     kvp.val = projectId;
                //     generateModel = true;
                // }                
            }                        
            else {
                if (checked) {
                    modelProjects.push({key: vendor, val: projectId});
                }                
            }
        }
        else {
            if (checked) {
                modelProjects.push({key: vendor, val: projectId});
            }            
        }
        this.setState({
            modelProjects
        });
        const modelProjectsClone = JSON.parse(JSON.stringify(modelProjects));
        this.props.adHocV2Actions.setGenerateModelGroup(modelProjectsClone);
        //this.props.adHocOcrV3Actions.setGenerateModel(projectId, generateModel);
    }

    // private getOcrForPage = async (page: number): Promise<IHatchetAiCompanyProjectOcr> => {
    //     const ocr = await this.props.adHocActions.getOcrProjectForPage(this.requestId, page, this.state.selectedAsset.asset.path, this.state.selectedAsset.asset.name);
    //     return ocr;
    // }

    // private updateDocumentOcr = async (assetName: string, ocr: string) => {
    //     await this.props.adHocActions.updateDocumentOcr(this.props.adHocOcr.project.id, this.props.adHocOcr.project.name, assetName, ocr);
    // }

    private async loadAdHocOcrProject(requestId: string) {
        if (this.state.selectedRequestId === requestId) { 
            return;
        }
        if (this.props.adHocOcrV3Group.adHocProjectProjectResults && this.props.adHocOcrV3Group.adHocProjectProjectResults.length > 0) {
            const project = this.props.adHocOcrV3Group.adHocProjectProjectResults.find(r => { 
                if (requestId == r.project['id']) {
                    return r;
                }
            });
            if (project) {
                this.props.adHocOcrV3Actions.loadAdHocOcrV3ProjectFromGroup(project);
                //await this.loadProjectAssets();   
                this.setState({
                    selectedRequestId: requestId,
                    isPageLoading: true
                }, async () => {
                    setTimeout(async () => {
                        await this.loadProjectAssets();
                    }, 300);     
                    if (!!this.canvas.current) {
                        if (project.status.toLowerCase() === 'ready') {
                            this.canvas.current.toggleDrawRegionMode(false);
                        }
                        else {
                            this.canvas.current.toggleDrawRegionMode(true);
                        }
                    }                    
                })
                               
            }
        }
        
    }

    render() {
        const { selectedAsset } = this.state;
        
        const isBasicInputMode = this.state.tagInputMode === TagInputMode.Basic;
        this.initialRightSplitPaneWidth = isBasicInputMode ? 290 : 520;

        const labels =
            (selectedAsset &&
                selectedAsset.labelData &&
                selectedAsset.labelData.labels) ||
            [];
        const tableLabels =
            (selectedAsset &&
                selectedAsset.labelData &&
                selectedAsset.labelData.tableLabels) ||
            [];

        return (
            <React.Fragment>
                <div className="editor-page skipToMainContent" id="pageEditor">
                    { this.state.isPageLoading && 
                    <div
                        className="project-loading"
                        style={{
                            zIndex: 1000, // Ensure it overlays all other elements
                            position: "fixed", // Full-screen overlay
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
                            display: "flex",
                            justifyContent: "center", // Center horizontally
                            alignItems: "center", // Center vertically
                        }}
                    >
                        <div
                            className="project-loading-content"
                            style={{
                                textAlign: "center",
                                animation: "fadeIn 0.5s ease-in-out", // Smooth fade-in animation
                            }}
                        >
                            <div
                                className="project-loading-spinner"
                                style={{
                                    marginBottom: "20px", // Add spacing between spinner and label
                                }}
                            >
                                <Spinner
                                    size={SpinnerSize.large}
                                    label="Loading Project..."
                                    ariaLive="assertive"
                                    labelPosition="bottom"
                                    styles={{
                                        root: {
                                            color: "#0078d4", // Blue spinner color
                                        },
                                        label: {
                                            fontSize: "16px", // Larger font for better readability
                                            color: "#333", // Dark gray text color
                                        },
                                    }}
                                />
                            </div>
                            <p
                                style={{
                                    fontSize: "14px",
                                    color: "#666", // Subtle gray text for additional information
                                    marginTop: "10px",
                                }}
                            >
                                Please wait while we load your project.
                            </p>
                        </div>
                    </div>
                    }                    
                    <div className="editor-page-content">
                        {this.state.tableToView !== null && (
                            <TableView
                                handleTableViewClose={this.handleTableViewClose}
                                tableToView={this.state.tableToView}
                            />
                        )}
                        <SplitPane
                            split="vertical"
                            defaultSize={248}
                            maxSize={325}
                            minSize={248}
                            paneStyle={{ display: "flex" }}                            
                            onChange={(width) => {
                                if (!isBasicInputMode) {
                                    //this.setState(
                                    //    {
                                    //        rightSplitPaneWidth: width > 700 ? 700 : width
                                    //    },
                                    //    () => {
                                    //        this.resizeCanvas();
                                    //    }
                                    //);
                                    this.setState(prevState => {
                                        return {
                                            ...prevState,
                                            rightSplitPaneWidth: width > 700 ? 700 : width
                                        }
                                    }, () => {
                                        this.resizeCanvas();
                                    })
                                    this.resizeCanvas();
                                }
                            }}
                        >
                            <div className="editor-page-sidebar text-right" style={{ paddingTop: '2px' }}>
                            
                                <EditorSideBar
                                    selectedAsset={
                                        selectedAsset ? selectedAsset.asset : null
                                    }
                                    onBeforeAssetSelected={this.onBeforeAssetSelected}
                                    onAssetSelected={this.selectAsset}
                                    thumbnailSize={this.state.thumbnailSize}
                                    projectLabels={this.state.projectLabels}
                                    ref={this.editorSidebarRef}
                                    adHocProjectGroup={this.props.adHocOcrV3Group}
                                    loadAdHocOcrProject={this.loadAdHocOcrProject}
                                    selectedRequestId={this.state.selectedRequestId}
                                    modelProjects={this.state.modelProjects}
                                    onGenerateModelChanged={this.onGenerateModelChanged}
                                    loadAdHocOcrV3GroupProjectDocument={this.props.adHocOcrV3Actions.loadAdHocOcrV3GroupProjectDocument}
                                    groupId={this.groupId}
                                    toggleProjectToPost={this.props.adHocOcrV3Actions.toggleProjectToPost}
                                    //refreshKey={this.props.adHocOcrV3Group.refreshKey}                                    
                                />
                            </div>
                            <div className="editor-page-content">
                            <SplitPane
                                defaultSize={this.initialRightSplitPaneWidth}
                                split="vertical"
                                primary="second"
                                maxSize={isBasicInputMode ? 400 : 600}
                                minSize={this.initialRightSplitPaneWidth}
                                className={"right-vertical_splitPane"}
                                pane1Style={{ height: "100%" }}
                                pane2Style={{ height: "auto" }}
                                resizerStyle={{
                                    width: "5px",
                                    margin: "0px",
                                    border: "2px",
                                }}
                                onChange={(width) => {
                                    this.setState(prevState => {
                                        return {
                                            ...prevState,
                                            rightSplitPaneWidth: width
                                        }
                                    }, () => {
                                        this.resizeCanvas();
                                    })
                                    this.resizeCanvas();
                                }}
                            >
                                <div className="editor-page-content-main">
                                    <div className="editor-page-content-main-body">
                                        {this.props?.adHocOcrV3?.status.toLowerCase() === "posted" && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white background
                                                    display: "flex",
                                                    justifyContent: "center", // Center horizontally
                                                    alignItems: "center", // Center vertically
                                                    zIndex: 100, // Ensure it appears above other content
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "24px", // Larger font size for the watermark
                                                        fontWeight: "bold", // Bold text for emphasis
                                                        color: "#0078d4", // Blue text color
                                                        opacity: 0.5, // Make the text semi-transparent
                                                        textTransform: "uppercase", // Make the text uppercase
                                                    }}
                                                >
                                                    Posted
                                                </span>
                                            </div>
                                        )}
                                        {/* {this.props?.adHocOcrV3?.status.toLowerCase() === "completed" && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: "100%",
                                                    height: "100%",
                                                    //backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white background
                                                    display: "flex",
                                                    justifyContent: "center", // Center horizontally
                                                    alignItems: "center", // Center vertically
                                                    zIndex: 100, // Ensure it appears above other content
                                                }}
                                            >
                                            </div>
                                        )} */}
                                        { this.props && this.props.adHocOcrV3 && this.props.adHocOcrV3.project && 
                                            this.state.selectedAsset && this.props.adHocOcrV3.status !== "Queued" &&
                                            <Canvas 
                                                key={this.state.selectedRequestId}
                                                ref={this.canvas}
                                                selectedAsset={
                                                    this.state.selectedAsset
                                                }
                                                onAssetMetadataChanged={
                                                    this.onAssetMetadataChanged
                                                }
                                                onCanvasRendered={
                                                    this.onCanvasRendered
                                                }
                                                onSelectedRegionsChanged={
                                                    this.onSelectedRegionsChanged
                                                }
                                                onRegionDoubleClick={
                                                    this.onRegionDoubleClick
                                                }
                                                onRunningOCRStatusChanged={
                                                    this.onCanvasRunningOCRStatusChanged
                                                }
                                                onRunningAutoLabelingStatusChanged={
                                                    this.onCanvasRunningAutoLabelingStatusChanged
                                                }
                                                onTagChanged={this.onTagChanged}
                                                onAssetDeleted={
                                                    this.confirmDocumentDeleted
                                                }
                                                editorMode={this.state.editorMode}
                                                project={this.props.adHocOcrV3.project}
                                                lockedTags={this.state.lockedTags}
                                                hoveredLabel={
                                                    this.state.hoveredLabel
                                                }
                                                setTableToView={this.setTableToView}
                                                closeTableView={this.closeTableView}
                                                runOcrForAllDocs={
                                                    this.loadOcrForNotVisited
                                                }
                                                isRunningOCRs={
                                                    this.state.isRunningOCRs
                                                }
                                                onPageLoaded={this.onPageLoaded}
                                                runAutoLabelingOnNextBatch={
                                                    this.runAutoLabelingOnNextBatch
                                                }
                                                appSettings={this.props.appSettings}
                                                handleLabelTable={
                                                    this.handleLabelTable
                                                }
                                                highlightedTableCell={
                                                    this.state
                                                        .highlightedTableCellRegions
                                                }
                                                showSearch={true}
                                                handlerSearch={this.onHandleSearch}
                                                showUploadGeneratedTagsToApi={this.showUploadGeneratedTagsToApi}     
                                                adHocOcr={this.props.adHocOcrV3}     
                                                // getOcrForPage={this.getOcrForPage}      
                                                //TODO: THIS IS NEEDED
                                                //updateAdHocOcrProjectOcr={this.props.adHocActions.updateAdHocOcrProjectOcr}       
                                                widgetMode={this.props.appSettings.widgetMode}      
                                                isV3={!!this.props.adHocOcrV3}        
                                                status={this.props.adHocOcrV3.status}       
                                            >
                                                <AssetPreview
                                                    controlsEnabled={
                                                        this.state.isValid
                                                    }
                                                    onBeforeAssetChanged={
                                                        this.onBeforeAssetSelected
                                                    }
                                                    asset={
                                                        this.state.selectedAsset
                                                            .asset
                                                    }
                                                />
                                            </Canvas>
                                        }                                    
                                    </div>
                                </div>

                                <div className="editor-page-right-sidebar">
                                {this.props?.adHocOcrV3?.status.toLowerCase() === "posted" && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: 0,
                                            left: 0,
                                            width: "100%",
                                            height: "100%",
                                            backgroundColor: "rgba(255, 255, 255, 0.7)", // Semi-transparent white background
                                            display: "flex",
                                            justifyContent: "center", // Center horizontally
                                            alignItems: "center", // Center vertically
                                            zIndex: 10, // Ensure it appears above other content
                                        }}
                                    >                                        
                                    </div>
                                )}
                                    {this.state.selectedAsset &&
                                        (<TagInput
                                            selectAllForDelete={false}
                                            project={this.props.adHocOcrV3.project}
                                            tagsLoaded={true}
                                            tags={this.props.adHocOcrV3.project.tags}
                                            lockedTags={this.state.lockedTags}
                                            selectedRegions={
                                                this.state.selectedRegions
                                            }
                                            labels={labels}
                                            encoded={
                                                selectedAsset?.labelData
                                                    ?.$schema ===
                                                constants.labelsSchema
                                            }
                                            tableLabels={tableLabels}
                                            pageNumber={this.state.pageNumber}
                                            onChange={this.onTagsChanged}
                                            onLockedTagsChange={
                                                this.onLockedTagsChanged
                                            }
                                            onTagClick={this.onTagClicked}
                                            onCtrlTagClick={
                                                this.onCtrlTagClicked
                                            }
                                            onTagRename={this.confirmTagRename}
                                            onTagDeleted={
                                                this.confirmTagDeleted
                                            }
                                            onDeleteSeletedTags={
                                                this.confirmTagsDeleted
                                            }
                                            onDeleteCheckedChanged={
                                                this.onTagDeleteChecked
                                            }
                                            onLabelEnter={this.onLabelEnter}                                        
                                            onLabelLeave={this.onLabelLeave}
                                            onTagChanged={this.onTagChanged}
                                            ref={this.tagInputRef}
                                            setTagInputMode={
                                                this.setTagInputMode
                                            }
                                            tagInputMode={
                                                this.state.tagInputMode
                                            }
                                            handleLabelTable={
                                                this.handleLabelTable
                                            }
                                            selectedTableTagToLabel={
                                                this.state
                                                    .selectedTableTagToLabel
                                            }
                                            handleTableCellClick={
                                                this.handleTableCellClick
                                            }
                                            handleTableCellMouseEnter={
                                                this.handleTableCellMouseEnter
                                            }
                                            handleTableCellMouseLeave={
                                                this.handleTableCellMouseLeave
                                            }
                                            selectedTableTagBody={
                                                this.state.selectedTableTagBody
                                            }
                                            splitPaneWidth={
                                                this.state.rightSplitPaneWidth
                                            }
                                            reconfigureTableConfirm={
                                                this.reconfigureTableConfirm
                                            }
                                            addRowToDynamicTable={
                                                this.addRowToDynamicTable
                                            }
                                            onTagDoubleClick={
                                                this.onLabelDoubleClicked
                                            }
                                            handelDownloadClick={(withTables: boolean) =>
                                                this.downloadToExcelClick(withTables)
                                            }
                                            onLabelEdit={this.onLabelEdit}
                                            onResetClick={this.onResetClick}
                                            confirmResetTag={this.confirmResetTag}
                                            toggleTagSpinner={this.toggleTagSpinner}
                                            widgetMode={this.props.appSettings.widgetMode}
                                            processingLabel={this.processingLabel} 
                                            onLabelClick={this.onLabelClick}
                                            isV3={!!this.props.adHocOcrV3.project}
                                            status={this.props.adHocOcrV3.status}
                                        />)
                                    }
                                </div>
                            </SplitPane>
                            </div>
                        </SplitPane>

                        <Confirm
                            ref={this.confirmResetTagConfirm}
                            title="Reset"
                            // tslint:disable-next-line:max-line-length
                            message={() =>
                                "Are you sure you want to reset the tag value?"
                            }
                            confirmButtonTheme={getPrimaryRedTheme()}
                            onConfirm={(label) => this.confirmResetTag(label)}
                            onCancel={() => this.onCancelResetTag()}
                        />

                        <SearchDialog
                            show={this.state.showSearch}
                            onClose={this.closeSearchDialog}
                            onSearchClick={this.onSearchButtonClick}
                            clearSearch={this.clearSearchButtonClick}
                            ref={this.searchDialogRef}
                            canvas={this.canvas}
                            fileName={
                                this.state.selectedAsset
                                    ? this.state.selectedAsset.asset.name
                                    : null
                            }
                            currentPage={
                                this.canvas.current
                                    ? this.canvas.current.currentPage()
                                    : 1
                            }
                            container={this.props.adHocOcrV3 ? this.props.adHocOcrV3 : null}
                        />

                        <EditLabelDialog
                            show={this.state.showEditDialog}
                            onClose={this.closeEditLabelDialog}
                            onSaveEditLabelClick={this.onSaveEditLabelClick}
                            ref={this.editLabelDialogRef}
                            container={this.props.adHocOcrV3?.project ? this.props.adHocOcrV3?.project : null}
                            label={this.state.labelToEdit}
                        />
                    </div>
                </div>                
            </React.Fragment>
        );
    }

    private toggleTagSpinner = (show: boolean) => {
        this.setState(prevState => {
            return {
                ...prevState,
                processingUploadedTags: show
            }
        });
    };

    private processingLabel = (processing: boolean) => {
        this.setState(prevState => {
            return {
                ...prevState,
                isProcessingLabel: processing
            }
        });
    }
    
    // private isBusy = (): boolean => {
    //     return (
    //         this.state.isRunningOCRs ||
    //         this.state.isCanvasRunningOCR ||
    //         this.state.isCanvasRunningAutoLabeling
    //     );
    // };

    private onCancelResetTag() {
        // this.setState({ showSearch: true });
    }


    private async confirmResetTag(label: ILabel) {
        const { selectedAsset } = this.state;
        if (selectedAsset && selectedAsset.labelData && selectedAsset.labelData.labels && selectedAsset.labelData.labels.length > 0) {
            selectedAsset.labelData.labels = selectedAsset.labelData.labels.filter((l) => l.label !== label.label);
        }        
        this.setState((prevState) => {
            return {
                ...prevState,
                clearingLabel: true
            }
        });

        try {
            const assetService = new AssetService(this.props.adHocOcrV3.project);

            // let newMeta = await this.props.actions.saveAssetMetadataAdhoc(
            //     this.props.adHocOcr.project,
            //     selectedAsset
            // );

            let newMeta = await this.props.actions.saveAssetMetadataAdhocV3(
                this.props.adHocOcrV3.project,
                selectedAsset
            );

            //TODO: THIS IS NEEDED
            //await this.props.adHocActions.updateAdHocOcrProjectAssetLabel(this.props.adHocOcr.project.id, this.props.adHocOcr.project.name, selectedAsset.asset.name, JSON.stringify(selectedAsset.labelData), false, '', this.state.runGenerateModel);

            await this.loadProjectAssets(true);
            await this.selectAsset(this.state.selectedAsset.asset, true);
            this.canvas.current.fullRedrawFeatures();

        } catch (error) {
            console.log(error);
        } finally {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    clearingLabel: false, 
                    isPageLoading: false
                }
            });
        }
    }

    private onLabelEdit = (label: ILabel) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                showEditDialog: true,
                labelToEdit: label
            }
        });
    };

    private closeEditLabelDialog = () => {        
        // this.setState((prevState) => {
        //     return {
        //         ...prevState,
        //         showEditDialog: false,
        //         labelToEdit: null
        //     }
        // });
        this.setState({
            showEditDialog: false,
            labelToEdit: null
        });
    };

    private onSaveEditLabelClick = async (
        event: SyntheticEvent,
        label: ILabel
    ) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                savingLabel: true
            }
        });

        this.canvas.current.applyTag(label.label, null, null, label);
        this.canvas.current.disableDrawRegionMode();

        setTimeout(() => {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    savingLabel: false
                }
            });
        }, 1000);
    };

    private onResetClick = (label: ILabel) => {
        this.confirmResetTagConfirm.current.open(label);
    };

    private downloadToExcelClick = async (withTables: boolean) => {
        // if (this.isBusy()) {
        //     return;
        // }

        const assets = this.props.adHocOcrV3.project.assets;

        let arrays = Array<string>();
        let keys = Object.keys(assets);

        for (let index = 0; index < keys.length; index++) {
            const key = keys[index];
            arrays.push(assets[key].name);
        }

        this.setState((prevState) => {
            return {
                ...prevState,
                downloading: true
            }
        });

        try {
            const response = await axios.post(
                parseEndpointByType("HachetDownloadExcel"),
                {
                    FileNames: arrays,
                    Name: this.props.adHocOcrV3.project.name,
                    Email: getCookieEmail(),
                    WithTables: withTables
                },
                {
                    headers: {
                        "Access-Control-Allow-Origin": "*",
                        withCredentials: "true",
                    },
                    responseType: "blob",
                }
            );

            if (response) {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    })
                );
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                    "download",
                    `"hachetai-result-${Math.round(+new Date() / 1000)}.xlsx`
                ); //or any other extension
                document.body.appendChild(link);
                link.click();

                this.setState((prevState) => {
                    return {
                        ...prevState,
                        downloading: false
                    }
                });
            }
        } catch (error) {
            console.log(error.response);
        }
    };

    private onLabelDoubleClicked = (label: ILabel) => {
        this.canvas.current.focusOnLabel(label);
    };

    private addRowToDynamicTable = () => {
        const selectedTableTagBody = clone()(this.state.selectedTableTagBody);
        selectedTableTagBody.push(
            Array(this.state.selectedTableTagToLabel.definition.fields.length)
        );
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTableTagBody
            }
        });
    };

    private handleTableCellMouseLeave = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                highlightedTableCellRegions: null
            }
        });
    };

    private handleTableCellMouseEnter = (regions) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                highlightedTableCellRegions: regions
            }
        });
    };

    private onTableTagClicked = (
        tag: ITag,
        rowIndex: number,
        columnIndex: number
    ): void => {
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTag: tag.name,
                lockedTags: []
            }
        },
            () => {
                this.canvas.current.applyTag(tag.name, rowIndex, columnIndex);
                this.canvas.current.disableDrawRegionMode();
            });
    };

    private handleTableCellClick = (rowIndex: number, columnIndex: number) => {
        if (
            !this.state.selectedRegions ||
            this.state.selectedRegions.length === 0
        ) {
            return;
        }

        if (
            this.state?.selectedTableTagBody?.[rowIndex]?.[columnIndex]
                ?.length > 0
        ) {
            const selectionRegionCatagory =
                this.state.selectedRegions[0].category;
            const cellCatagory =
                this.state.selectedTableTagBody[rowIndex][columnIndex][0]
                    .category;
            if (
                selectionRegionCatagory !== cellCatagory &&
                (selectionRegionCatagory === FeatureCategory.DrawnRegion ||
                    cellCatagory === FeatureCategory.DrawnRegion)
            ) {
                this.replaceConfirmRef.current.open(
                    this.state.selectedTableTagToLabel,
                    rowIndex,
                    columnIndex
                );
                return;
            }
        }

        this.onTableTagClicked(
            this.state.selectedTableTagToLabel,
            rowIndex,
            columnIndex
        );
    };

    private setTagInputMode = (
        tagInputMode: TagInputMode,
        selectedTableTagToLabel: ITableTag = this.state.selectedTableTagToLabel,
        selectedTableTagBody: ITableRegion[][][] = this.state.selectedTableTagBody
    ) => {
        // this.resizeCanvas();

        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTableTagBody,
                selectedTableTagToLabel,
                tagInputMode,
            }
        },
            () => {
                this.resizeCanvas();
            });
    };

    clearSearchButtonClick = async () => {
        if (this.canvas.current) await this.canvas.current.resetCurrentPage();
    };

    private onSearchButtonClick = async (
        event: SyntheticEvent,
        params: ILabel
    ) => {
        if (params) {
            await this.canvas.current.goToPage(params.value[0].page);

            setTimeout(() => {
                this.canvas.current.highlightFoundRegions(params);

                this.closeSearchDialog();
            }, 500);
        } else {
            await this.canvas.current.goToPage(1);
        }
    };

    private closeSearchDialog = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                showSearch: false
            }
        });
    };

    private onLabelLeave = (label: ILabel) => {
        this.setState({ hoveredLabel: null });
    };

    private onLabelEnter = (label: ILabel) => {
        this.setState({ hoveredLabel: label });
    };

    private onLabelClick = async (label: ILabel) => {
        //this.onSearchButtonClick(null, label);
        await this.canvas.current.goToPage(label.value[0].page);
        this.setState({ hoveredLabel: null }, () => {
            setTimeout(() => {
                this.setState({ hoveredLabel: label });        
            }, 500);
        });        
    };

    private confirmTagsDeleted = (tagLabelMap: Map<string, ILabel[]>): void => {
        this.deleteTagsConfirm.current.open(tagLabelMap);
    };
    
    private confirmTagDeleted = (
        tagName: string,
        tagType: FieldType,
        tagFormat: FieldFormat,
        labels?: ILabel[]
    ): void => {
        this.deleteTagConfirm.current.open(tagName, tagType, tagFormat, labels);
    };

    private confirmTagRename = (
        tag: ITag,
        newTag: ITag,
        cancelCallback: () => void
    ): void => {
        this.renameCanceled = cancelCallback;
        this.renameTagConfirm.current.open(tag, newTag);
    };

    private onCtrlTagClicked = (tag: ITag): void => {
        const locked = this.state.lockedTags;
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTag: tag.name,
                lockedTags: CanvasHelpers.toggleTag(locked, tag.name)
            }
        },
            () => {
                this.canvas.current.applyTag(tag.name);
                this.canvas.current.disableDrawRegionMode();
            });
    };

    private onTagClicked = (tag: ITag): void => {
        this.setState((prevState) => {
            return {
                ...prevState,
                selectedTag: tag.name,
                lockedTags: [],
                runGenerateModel: true
            }
        },
            () => {
                this.canvas.current.applyTag(tag.name);
                // this.canvas.current.disableDrawRegionMode();
            });
    };

    private onLockedTagsChanged = (lockedTags: string[]) => {
        this.setState(prevState => {
            return {
                ...prevState,
                lockedTags
            }
        });
    };

    private onTagsChanged = async (tags, tagChangedCallback?: any) => {
        const project = {
            ...this.props.adHocOcrV3.project,
            tags,
        };
        //TODO: Save Project
        //await this.props.actions.saveProject(project, true, false, this.savedToken);
        if (tagChangedCallback) {
            tagChangedCallback();
        }
    };

    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    };

    private onSideBarResize = (newWidth: number) => {
        this.setState((prevState) => {
            return {
                ...prevState,
                thumbnailSize: {
                    width: newWidth,
                    height: newWidth / (4 / 3),
                }
            }
        });
        this.resizeCanvas();
    };

    private resizeCanvas = () => {
        if (this.canvas.current) {
            this.canvas.current.updateSize();
        }
    };

    private compareAssetLabelsWithProjectTags = (
        labels: ILabel[],
        tags: ITag[]
    ): boolean => {
        if (!labels || labels.length === 0) {
            return false;
        }
        const intersectionTags = _.intersectionWith(
            labels,
            tags,
            (l, t) => l.label === t.name
        );
        return intersectionTags?.length < labels.length;
    };

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (
        assetMetadata: IAssetMetadata
    ): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.
        assetMetadata = _.cloneDeep(assetMetadata);
        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        // Only update asset metadata if state changes or is different
        if (
            initialState !== asset.state ||
            this.state.selectedAsset !== assetMetadata
        ) {
            if (
                JSON.stringify(assetMetadata.labelData) !==
                JSON.stringify(this.state.selectedAsset.labelData)
            ) {
                await this.updatedAssetMetadata(assetMetadata);
            }

            assetMetadata.asset = asset;
            let newMeta = await this.props.actions.saveAssetMetadataAdhocV3(
                this.props.adHocOcrV3.project,
                assetMetadata
            );
            //TODO: THIS IS NEEDED
            //await this.props.adHocActions.updateAdHocOcrProjectAssetLabel(this.props.adHocOcr.project.id, this.props.adHocOcr.project.name, assetMetadata.asset.name, JSON.stringify(assetMetadata.labelData), false, '', this.state.runGenerateModel);

            // Get regions from label data since meta data will not have regions when loaded.
            newMeta.regions =
            this.canvas.current?.convertLabelDataToRegions(
                newMeta.labelData
            ) || [];
            this.setState(prevState => {
                return {
                    ...prevState,
                    selectedAsset: newMeta
                }
            });
            if (
                this.compareAssetLabelsWithProjectTags(
                    assetMetadata.labelData?.labels,
                    this.props.adHocOcrV3.project.tags
                )
            ) {
                // await this.props.actions.updateProjectTagsFromFiles(
                //     this.props.adHocOcr.project,
                //     assetMetadata.asset.name
                // );
            }
        }
    };

    private async updatedAssetMetadata(assetMetadata: IAssetMetadata) {
        const rowDocumentCountDifference = {};
        const updatedRowLabels = {};
        const currentRowLabels = {};
        const columnDocumentCountDifference = {};
        const updatedColumnLabels = {};
        const currentColumnLabels = {};
        assetMetadata?.labelData?.tableLabels?.forEach((table) => {
            updatedRowLabels[table.tableKey] = {};
            updatedColumnLabels[table.tableKey] = {};
            table.labels.forEach((label) => {
                updatedRowLabels[table.tableKey][label.rowKey] = true;
                updatedColumnLabels[table.tableKey][label.columnKey] = true;
            });
        });

        this.state.selectedAsset?.labelData?.tableLabels?.forEach((table) => {
            currentRowLabels[table.tableKey] = {};
            currentColumnLabels[table.tableKey] = {};
            table.labels.forEach((label) => {
                currentRowLabels[table.tableKey][label.rowKey] = true;
                currentColumnLabels[table.tableKey][label.columnKey] = true;
            });
        });

        Object.keys(currentColumnLabels).forEach((table) => {
            Object.keys(currentColumnLabels[table]).forEach((columnKey) => {
                if (!updatedColumnLabels?.[table]?.[columnKey]) {
                    if (!(table in columnDocumentCountDifference)) {
                        columnDocumentCountDifference[table] = {};
                    }
                    columnDocumentCountDifference[table][columnKey] = -1;
                }
            });
        });

        Object.keys(updatedColumnLabels).forEach((table) => {
            Object.keys(updatedColumnLabels[table]).forEach((columnKey) => {
                if (!currentColumnLabels?.[table]?.[columnKey]) {
                    if (!(table in columnDocumentCountDifference)) {
                        columnDocumentCountDifference[table] = {};
                    }
                    columnDocumentCountDifference[table][columnKey] = 1;
                }
            });
        });

        Object.keys(currentRowLabels).forEach((table) => {
            Object.keys(currentRowLabels[table]).forEach((rowKey) => {
                if (!updatedRowLabels?.[table]?.[rowKey]) {
                    if (!(table in rowDocumentCountDifference)) {
                        rowDocumentCountDifference[table] = {};
                    }
                    rowDocumentCountDifference[table][rowKey] = -1;
                }
            });
        });

        Object.keys(updatedRowLabels).forEach((table) => {
            Object.keys(updatedRowLabels[table]).forEach((rowKey) => {
                if (!currentRowLabels?.[table]?.[rowKey]) {
                    if (!(table in rowDocumentCountDifference)) {
                        rowDocumentCountDifference[table] = {};
                    }
                    rowDocumentCountDifference[table][rowKey] = 1;
                }
            });
        });

        const assetDocumentCountDifference = {};
        const updatedAssetLabels = {};
        const currentAssetLabels = {};
        assetMetadata.labelData?.labels?.forEach((label) => {
            updatedAssetLabels[label.label] = true;
        });
        this.state.selectedAsset.labelData?.labels?.forEach((label) => {
            currentAssetLabels[label.label] = true;
        });
        Object.keys(currentAssetLabels).forEach((label) => {
            if (!updatedAssetLabels[label]) {
                assetDocumentCountDifference[label] = -1;
            }
        });
        Object.keys(updatedAssetLabels).forEach((label) => {
            if (!currentAssetLabels[label]) {
                assetDocumentCountDifference[label] = 1;
            }
        });
    }

    /**
     * Raised when the asset binary has been painted onto the canvas tools rendering canvas
     */
    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
    };

    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
        if (this.state.isProcessingLabel) {
            return;
        }
        this.setState(prevState => {
            return {
                ...prevState,
                selectedRegions
            }
        });
    };

    private onRegionDoubleClick = (region: IRegion) => {
        if (region.tags?.length > 0 && this.tagInputRef.current) {
            this.tagInputRef.current.focusTag(region.tags[0]);
        }
    };

    private onCanvasRunningOCRStatusChanged = (ocrStatus: OcrStatus) => {
        
    };

    private onCanvasRunningAutoLabelingStatusChanged = (
        isCanvasRunningAutoLabeling: boolean
    ) => {
        //this.setState({ isCanvasRunningAutoLabeling });
    };

    private onTagChanged = async (oldTag: ITag, newTag: ITag) => {
        // const assetUpdates = await this.props.actions.updateProjectTag(
        //     this.props.project,
        //     oldTag,
        //     newTag
        // );
        // const selectedAsset = assetUpdates.find(
        //     (am) => am.asset.id === this.state.selectedAsset.asset.id
        // );

        // if (selectedAsset) {
        //     this.setState({
        //         selectedAsset,
        //     });
        // }
    };

    /**
     * Open Confirm dialog for document deletion
     */
    private confirmDocumentDeleted = (): void => {
        //this.deleteDocumentConfirm.current.open();
    };

    private setTableToView = async (tableToView, tableToViewId) => {
        if (this.state.tableToViewId) {
            this.canvas.current.setTableState(this.state.tableToViewId, "rest");
        }
        this.canvas.current.setTableState(tableToViewId, "selected");
        this.setState({
            tableToView,
            tableToViewId,
        });
    };

    private closeTableView = (state: string) => {
        if (this.state.tableToView) {
            this.canvas.current.setTableState(this.state.tableToViewId, state);
            this.setState({
                tableToView: null,
                tableToViewId: null,
            });
        }
    };

    public loadOcrForNotVisited = async (runForAll?: boolean) => {
        
    };

    private reconfigureTableConfirm = (
        originalTagName: string,
        tagName: string,
        tagType: FieldType.Array | FieldType.Object,
        tagFormat: FieldFormat,
        visualizationHint: TableVisualizationHint,
        deletedColumns: ITableConfigItem[],
        deletedRows: ITableConfigItem[],
        newRows: ITableConfigItem[],
        newColumns: ITableConfigItem[]
    ) => {
        this.setState({ reconfigureTableConfirm: true });
        this.reconfigTableConfirm.current.open(
            originalTagName,
            tagName,
            tagType,
            tagFormat,
            visualizationHint,
            deletedColumns,
            deletedRows,
            newRows,
            newColumns
        );
    };

    private onTagDeleteChecked() {
        
    }

    private onPageLoaded = async (pageNumber: number) => {
        this.setState(prevState => {
            return {
                ...prevState,
                pageNumber,
                isPageLoading: false
            }
        });     
    };

    private runAutoLabelingOnNextBatch = async (batchSize: number) => {
        
    };

    private handleLabelTable = (
        tagInputMode: TagInputMode = this.state.tagInputMode,
        selectedTableTagToLabel: ITableTag = this.state.selectedTableTagToLabel
    ) => {
        
    };

    private onHandleSearch = () => {
        // if (!this.canvas.current.areAllPagesOCR()) {
        //     this.confirmOCRSearchAll.current.open();
        // } else {
        // }
        this.setState((prevState) => {
            return {
                ...prevState,
                showSearch: true
            }
        });
    };

    private showUploadGeneratedTagsToApi() {
        this.setState((prevState) => {
            return {
                ...prevState,
                showUploadTagsModal: true,
                uploadTagsModalKey: new Date().getTime()
            }
        });
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    showInvalidRegionWarning: true
                }
            });
        }

        return this.state.isValid;
    };

    private selectAsset = async (
        asset: IAsset,
        force: boolean = false
    ): Promise<void> => {
        // Nothing to do if we are already on the same asset.
        if (
            !force &&
            this.state.selectedAsset &&
            this.state.selectedAsset.asset.id === asset.id
        ) {
            return;
        }

        if (!this.state.isValid) {
            this.setState(prevState => {
                return {
                    ...prevState,
                    showInvalidRegionWarning: true
                }
            });
            return;
        }
        

        const self = this;

        this.setState(prevState => {
            return {
                ...prevState,
                processingSelectedAsset: true,
                isPageLoading: true
            }
        }, async () => {
            
            const assetMetadata = await self.props.actions.loadAssetMetadataAdhocV3(
                self.props.adHocOcrV3.project,
                asset,
                self.props.adHocOcrV3.labels
            );

            // Get regions from label data since meta data will not have regions when loaded.
            assetMetadata.regions =
                this.canvas.current?.convertLabelDataToRegions(
                    assetMetadata.labelData
                ) || [];

            self.setState(prevState => {
                return {
                    ...prevState,
                    tableToView: null,
                    tableToViewId: null,
                    selectedAsset: assetMetadata,
                    processingSelectedAsset: false
                }
            }
                
            )
        })
    };

    private loadProjectAssets = async (
        force: boolean = false
    ): Promise<void> => {
        // if (this.loadingProjectAssets) {
        //     return;
        // }

        // this.loadingProjectAssets = true;
        // const replacer = (key, value) => {
        //     if (key === "cachedImage") {
        //         return undefined;
        //     } else {
        //         return value;
        //     }
        // };

        try {
            const keys = Object.keys(this.props.adHocOcrV3.project.assets);
            let assets = keys.map(key => this.props.adHocOcrV3.project.assets[key]);

            this.setState(
                {
                    assets: assets
                },
                async () => {
                    if (assets.length > 0) {
                        await this.selectAsset(assets[0]);
                    }                    
                }
            );
        } catch (error) {
            throw Error(error);
        }
        finally {
            //this.loadingProjectAssets = false;
        }
    };
}
